import { render, staticRenderFns } from "./TestimonialFour.vue?vue&type=template&id=df3a11c2&"
import script from "./TestimonialFour.vue?vue&type=script&lang=js&"
export * from "./TestimonialFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports